'use client';

import * as Headless from '@headlessui/react';
import { forwardRef } from 'react';
import { isEnglishOnlyPrivatePath } from '@/lib/i18n/english-only-private-paths';
import { LocaleLink } from '@/lib/i18n/navigation';

type LinkPropsType = React.ComponentProps<typeof LocaleLink>;

export const Link: React.ForwardRefExoticComponent<
  LinkPropsType & React.RefAttributes<HTMLAnchorElement>
> = forwardRef(function Link(
  props: LinkPropsType,
  ref: React.ForwardedRef<HTMLAnchorElement>,
): React.JSX.Element {
  const href = typeof props.href === 'string' ? props.href : props.href?.pathname;
  const forcedLocale = href && isEnglishOnlyPrivatePath(href) ? 'en' : props.locale;
  return (
    <Headless.DataInteractive>
      <LocaleLink ref={ref} {...props} locale={forcedLocale} />
    </Headless.DataInteractive>
  );
});
